/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import React, { useState } from 'react';
import EmpProfile from '../../../../common/components/EmpProfile/EmpProfile';
import { fonts, themes } from '../../../../common/themes/themes';
import SearchComponent from '../../../../common/components/SearchComponent';
import _ from 'lodash';
import { DateField } from '../../../../components';
import {
  baseDateFormatting,
  baseTimeFormatting,
} from '../../../../common/helper';

interface propMyTraining {
  trans?: any;
  i18n?: any;
  mytrainingData: any;
}
const MyTrainingPresenter: React.FC<propMyTraining> = ({
  mytrainingData,
  trans,
}) => {
  const [pageSize, setPageSize] = React.useState<number>(10);
  const [textFiltertraining, setTextFiltertraining] = useState('');

  const filtertrainingList = () => {
    if (textFiltertraining.length) {
      const txt = textFiltertraining.toLowerCase();
      const res = _.filter(mytrainingData, function (e) {
        return e?.trainingtype.toLowerCase().includes(txt);
      });

      return res;
    } else {
      return mytrainingData;
    }
  };

  const handleGetTextFilter = (value: any) => {
    setTextFiltertraining(value);
  };

  const tableColumns: any = [
    {
      field: 'trainingtype',
      headerName: trans('Training Type'),
      width: 50,
      headerClassName: 'header',
      height: 90,
      flex: 1,
    },
    {
      field: 'trainer',
      headerName: trans('Trainer'),
      width: 250,
      headerClassName: 'header',
      height: 90,
      flex: 2,
      renderCell: (params: any) => {
        return (
          <EmpProfile avatar={params.row.avatar} name={params?.row?.trainer} />
        );
      },
    },
    {
      field: 'timezone',
      headerName: trans('timezone'),
      width: 250,
      headerClassName: 'header',
      height: 90,
      flex: 2,
      renderCell: (params: any) => {
        return params.row?.timezone?.timezone;
      },
    },
    {
      field: 'startdate',
      headerName: trans('Start Date'),
      headerClassName: 'header',
      height: 70,
      flex: 1,
      renderCell: (params: any) => {
        return (
          <DateField
            value={params.row.startdate}
            format={baseDateFormatting}
            offset={params?.row?.timezone?.offset}
          />
        );
      },
    },
    {
      field: 'enddate',
      headerName: trans('End Date'),
      headerClassName: 'header',
      height: 70,
      flex: 1,
      renderCell: (params: any) => {
        return (
          <DateField
            value={params.row.enddate}
            format={baseDateFormatting}
            offset={params?.row?.timezone?.offset}
          />
        );
      },
    },
    {
      field: 'starttime',
      headerName: trans('Start Time'),
      headerClassName: 'header',
      height: 70,
      flex: 1,
      renderCell: (params: any) => {
        return (
          <DateField
            value={params.row.starttime}
            format={baseTimeFormatting}
            offset={params?.row?.timezone?.offset}
          />
        );
      },
    },
    {
      field: 'endtime',
      headerName: trans('End Time'),
      headerClassName: 'header',
      height: 70,
      flex: 1,
      renderCell: (params: any) => {
        return (
          <DateField
            value={params.row.endtime}
            format={baseTimeFormatting}
            offset={params?.row?.timezone?.offset}
          />
        );
      },
    },
    {
      field: 'score',
      headerName: trans('Score'),
      headerClassName: 'header',
      height: 70,
      flex: 1,
    },
    {
      field: 'status',
      headerName: trans('Status'),
      headerClassName: 'header',
      height: 70,
      flex: 1,
      renderCell: (params: any) => {
        return params?.row?.status == 'Scheduled' ? (
          <Typography
            style={{
              color: themes.yellow,
              fontFamily: fonts.fontFamily,
              fontSize: fonts.subtitle,
              textTransform: 'capitalize',
              fontWeight: 'bold',
            }}
          >
            {trans(params?.row?.status)}
          </Typography>
        ) : params?.row?.status == 'Passed' ? (
          <Typography
            style={{
              color: themes.green,
              fontFamily: fonts.fontFamily,
              fontSize: fonts.subtitle,
              textTransform: 'capitalize',
              fontWeight: 'bold',
            }}
          >
            {trans(params?.row?.status)}
          </Typography>
        ) : params?.row?.status == 'Absent' ? (
          <Typography
            style={{
              color: themes.red,
              fontFamily: fonts.fontFamily,
              fontSize: fonts.subtitle,
              textTransform: 'capitalize',
              fontWeight: 'bold',
            }}
          >
            {trans(params?.row?.status)}
          </Typography>
        ) : params?.row?.status == 'Failed' ? (
          <Typography
            style={{
              color: themes.red,
              fontFamily: fonts.fontFamily,
              fontSize: fonts.subtitle,
              textTransform: 'capitalize',
              fontWeight: 'bold',
            }}
          >
            {trans(params?.row?.status)}
          </Typography>
        ) : params?.row?.status == 'Completed' ? (
          <Typography
            style={{
              color: '#0C2372',
              fontFamily: fonts.fontFamily,
              fontSize: fonts.subtitle,
              textTransform: 'capitalize',
              fontWeight: 'bold',
            }}
          >
            {trans(params?.row?.status)}
          </Typography>
        ) : params?.row?.status == 'Canceled' ? (
          <Typography
            style={{
              color: themes.red,
              fontFamily: fonts.fontFamily,
              fontSize: fonts.subtitle,
              textTransform: 'capitalize',
              fontWeight: 'bold',
            }}
          >
            {trans(params?.row?.status)}
          </Typography>
        ) : (
          ''
        );
      },
    },
  ];

  return (
    <>
      <SearchComponent onChange={handleGetTextFilter} />
      <Box style={{ maxHeight: '30em', overflowY: 'auto' }}>
        <DataGrid
          sx={{
            fontSize: fonts.subtitle,
            color: '#081735',
            fontFamily: fonts.fontFamily,
            marginTop: '1.5em',
          }}
          autoHeight
          disableColumnMenu
          pageSize={pageSize}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          rowsPerPageOptions={[10]}
          disableSelectionOnClick
          rows={filtertrainingList()}
          columns={tableColumns}
        />
      </Box>
    </>
  );
};
export default MyTrainingPresenter;
